import { Inject, Injectable } from '@angular/core';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormSaveBind } from './model/form-save-bind.model';
import { STATUS } from '../../common/use-loading.model';

@Injectable({
  providedIn: 'root',
})
export class EoFormTableService {
  fetchData$ = new BehaviorSubject<any[] | null>([]);
  fetchStatus$ = new BehaviorSubject<STATUS>(STATUS.pending);
  fetchError$ = new BehaviorSubject<string | null>(null);

  addData$ = new BehaviorSubject<any | null>(null);
  addStatus$ = new BehaviorSubject<STATUS>(STATUS.pending);
  addError$ = new BehaviorSubject<string | null>(null);

  updateData$ = new BehaviorSubject<any | null>(null);
  updateStatus$ = new BehaviorSubject<STATUS>(STATUS.pending);
  updateError$ = new BehaviorSubject<string | null>(null);

  deleteStatus$ = new BehaviorSubject<STATUS>(STATUS.pending);
  deleteError$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  fetch(url: string): Observable<any[]> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.fetchData$,
      status$: this.fetchStatus$,
      error$: this.fetchError$,
    };

    return this.http.get<any[]>(param);
  }

  add(url: string, saveBind: FormSaveBind): Observable<any> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.fetchData$,
      status$: this.fetchStatus$,
      error$: this.fetchError$,
      body: saveBind,
    };

    return this.http.post<any>(param);
  }

  update(url: string, updateBind: FormSaveBind): Observable<any> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.fetchData$,
      status$: this.fetchStatus$,
      error$: this.fetchError$,
      body: updateBind,
    };

    return this.http.put<any>(param);
  }

  delete(url: string, fieldIds: string[]): Observable<any> {
    const param: IHttpParams = {
      url: `${this.apiUrl}/${url}`,
      success$: this.fetchData$,
      status$: this.fetchStatus$,
      error$: this.fetchError$,
      body: fieldIds,
    };

    return this.http.delete<any>(param);
  }
}
